
SJ.ParalaxObject =
class {
  constructor(pos, scale, workingName, audioArr=[]) {
    this.x = pos.x;
    this.y = pos.y;

    this.audioArr = audioArr;
    this.scaleForAudio = parseFloat(scale);

    this.scale = typeof scale === 'string' ? 1.0 : scale;

    this.workingName = workingName;
  }

  draw(layerTranslateX, layerTranslateY, cameraTranslateX, cameraTranslateY, camScale) {

    push();

        translate(this.x, this.y);
        translate(layerTranslateX, layerTranslateY);
        translate(cameraTranslateX*camScale, cameraTranslateY*camScale);

        // translate(this.x + layerTranslate, this.y + cameraTranslate);

        scale(this.scale);
        this._drawSelf();

    pop();

    const camPos = SJ.camera.getPosition();

    this.audioArr.forEach(audio => {
      let audioX = this.x + layerTranslateX + camPos.x*camScale;
      let audioY = this.y + layerTranslateY + camPos.y*camScale;

      if(this.animation){
        audioX += this.animation.moveX * this.scaleForAudio || 0;
        audioY += this.animation.moveY * this.scaleForAudio || 0;
      }

      if(cameraTranslateX === 0 && cameraTranslateY === 0){
        audioX += SJ.V.textureOffset.x;
        audioY += SJ.V.textureOffset.y;
      }

      // push();
      //   fill(0, 255 ,0);
      //   rect(audioX + audio.translateX, audioY + audio.translateY, 15, 15);
      //   fill(255, 0, 0);
      //   text(audio.name, audioX + audio.translateX, audioY + audio.translateY);
      // pop();

      // if(this.workingName === 'gitara'){
      //   console.log(audioX, audioY);
      // }

      SJ.gameSoundsContainer.controlSpecificAudio(audio.name, '_update',
      [
        audioX, audioY
      ]);

    });
  }

  _drawSelf() {}
}

SJ.ParalaxImage =
class extends SJ.ParalaxObject {
  constructor(imgName, pos, workingName = null, scale = 1, subrect = null, audio = null, isSpriteSheetTexture = false, tilemap = null) {
    super(pos, scale, workingName, audio);
    this.img = SJ.ImageLoader.load(imgName);
    this.subrect = subrect;

    if (isSpriteSheetTexture && tilemap) {
      this.isSpriteSheetTexture = isSpriteSheetTexture;
      this.tilemap = tilemap;
    }
  }

  _drawSelf() {
    if (this.isSpriteSheetTexture) {

      for (let tileIndex in this.tilemap.tiles) {
        let tile = this.tilemap.tiles[tileIndex];

        tile.ssW = tile.ssW ?? this.tilemap['tile-dimensions'].w;
        tile.ssH = tile.ssH ?? this.tilemap['tile-dimensions'].h;

        image(this.img, tile.x, tile.y, tile.ssW, tile.ssH, tile.ssX, tile.ssY, tile.ssW, tile.ssH);
      }

    }
    else if(this.subrect) {
      image(this.img, 0, 0, this.subrect.w, this.subrect.h, this.subrect.x, this.subrect.y, this.subrect.w, this.subrect.h);
    }else {
      image(this.img, 0, 0);
    }
  }
}

SJ.ParalaxSpriteSheet =
class extends SJ.ParalaxObject {
  constructor(ssName, pos, frameWidth, frameHeight, framesCount, workingName, scale, duration, pointsToTrack, lerpSens, moveTo, moveDuration, audio) {
    super(pos, `${scale}`, workingName, audio);

    this.animation = new SJ.AnimationSpriteSheet(ssName, frameWidth, frameHeight, framesCount, duration, true, true, true, null, pointsToTrack, lerpSens, moveTo, moveDuration, scale);
  }

  _drawSelf() {
    this.animation.draw();
  }
}
SJ.ParalaxKeyFrames=
class extends SJ.ParalaxObject {
  constructor(keyFrames,pos,workingName, subrect,scale,pointsToTrack,lerpSens,moveTo,moveDuration, audio){
    super(pos, `${scale}`, workingName, audio);

    const frames = [];
    const framesDurationTimes = [];
    const framesTimesFromBeginOfAnimation = [];
    const framesTranslates = [];
    const subrects = [];
    const framesScales = [];

    let wholeAnimationDuration = 0;

    const emptyImage = createImage(1,1);
    let translate = {
      x: 0,
      y: 0
    }

    keyFrames.forEach(frameId => {
      if(frameId.frameSourceImage != null)
        frames.push(SJ.ImageLoader.load(frameId.frameSourceImage));
      else
        frames.push(emptyImage);


      if(frameId.subrect)
        subrects.push(frameId.subrect);
      else
        subrects.push(null);

      framesDurationTimes.push(frameId.frameDuration);
      wholeAnimationDuration+=frameId.frameDuration;

      if(frameId.translate)
        translate = frameId.translate;

      framesTranslates.push(translate);

      if(frameId.scale)
        framesScales.push(frameId.scale);
      else
        framesScales.push(scale);

    });

    this.animation = new SJ.KeyFramesAnimation(frames,framesDurationTimes,framesTranslates,subrects,framesScales,pointsToTrack,lerpSens,moveTo,moveDuration,wholeAnimationDuration,scale,true,true,true);

  }
  _drawSelf() {
    this.animation.draw();
  }
}
SJ.ParalaxLayer =
class {
  constructor(scale, pos, data) {
    this.camScale = data.movingStrength || scale;
    this.scale = 1.0;
    this.x = pos.x;
    this.y = pos.y;
    this.images = [];

    this.isMoving = data.isMoving || true;
    this.translate = data.translate ||  {
      "x": 0,
      "y": 0
    };

    if(this.isMoving === "false")
      this.camScale = SJ.V.cameraScale;

    this._prepareData(data);
  }

  _prepareData(data) {
    if(typeof data === "object") {
      if(data.type === "array") {
        data.array.forEach(img => {
          this._prepareImgFromObject(img);
        });
      }else {
        this._prepareImgFromObject(data);
      }

      if(data.followScale !== undefined) {
        this.camScale *= data.followScale;
      }
    }else if(typeof data === "string") {
      this.images.push(new SJ.ParalaxImage(data, { x: 0, y: 0 }, 1.0, null));
    }else {
      print("Error, unexpected type of data:", typeof data);
    }
  }

  _prepareImgFromObject(idxBg) {
    const subrect = idxBg.subrect || null;
    const imgPos = {
      x: 0,
      y: 0
    }
    if(idxBg.position) {
      imgPos.x += idxBg.position.x;
      imgPos.y += idxBg.position.y;
    }
    const scale = idxBg.scale || 1.0;

    let obj;

    this.audioArr = [];

    if(idxBg.randomAudio){
      idxBg.audio = [random(idxBg.audio)];
    }

    if(idxBg.audio && SJ.settings.SFX){
      idxBg.audio.forEach(audio => {

        if(typeof audio.fileName === 'string'){

          const audioTranslateX = audio.translateX || 0;
          const audioTranslateY = audio.translateY || 0;

          const soundName = audio.name || 'no-name';
          const fileName = audio.fileName;

          const volume = audio.volume || 0.1;
          const loop = audio.loop || true;
          const loopInterval = audio.loopInterval || 0;

          const soundPropagationDistance = audio.propagationDistance || 1000;

          let x = imgPos.x || 0;
          let y = imgPos.y || 0;

          const audioMoveCorection = audio.moveCorection || 1;

          const earsPostionX = audio.earsPostionX || SJ.SCREEN_MIDDLE_X;
          const earsPostionY = audio.earsPostionY || SJ.SCREEN_MIDDLE_Y;

          const sound = new SJ.Sound(soundName, fileName, volume, loop, false, null, soundPropagationDistance, x, y, earsPostionX, earsPostionY, null, false, loopInterval, audioTranslateX, audioTranslateY);

          this.audioArr.push(sound)

          SJ.gameSoundsContainer.addSound(sound);
        }

      });



    }


    if(idxBg.ssName){

      if(idxBg.pointsToTrack){

        const trackingSpriteSheet = new SJ.ParalaxSpriteSheet(idxBg.ssName, imgPos, idxBg.frameWidth, idxBg.frameHeight, idxBg.framesCount, idxBg.workingName, scale, idxBg.duration, idxBg.pointsToTrack, idxBg.lerpSens, null, null);

        SJ.main.appendDrawable(trackingSpriteSheet);
      }
      else{
        obj = new SJ.ParalaxSpriteSheet(idxBg.ssName, imgPos, idxBg.frameWidth, idxBg.frameHeight, idxBg.framesCount, idxBg.workingName, scale, idxBg.duration, null, null, idxBg.moveTo, idxBg.moveDuration)
      }

    }
    else if(idxBg.pointsToTrack && idxBg.keyFrames) {

      const trackingKeyFrames = new SJ.ParalaxKeyFrames(idxBg.keyFrames,imgPos,idxBg.workingName,idxBg.subrect,scale,idxBg.pointsToTrack,idxBg.lerpSens,null,null);

      SJ.main.appendDrawable(trackingKeyFrames);

    }
    else if(idxBg.moveTo && idxBg.moveDuration && idxBg.keyFrames){

      obj = new SJ.ParalaxKeyFrames(idxBg.keyFrames,imgPos,idxBg.workingName,idxBg.subrect,scale,null,null,idxBg.moveTo,idxBg.moveDuration);

    }
    else if(idxBg.keyFrames){

      if(SJ.settings.animations)
        obj = new SJ.ParalaxKeyFrames(idxBg.keyFrames,imgPos,idxBg.workingName,idxBg.subrect,scale,null,null,null,null);
      else
        obj = new SJ.ParalaxImage(idxBg.keyFrames[0].frameSourceImage, imgPos, idxBg.workingName, scale, idxBg.subrect);

    } else if (idxBg.noImage) {
      obj = new SJ.UI.Element(imgPos.x, imgPos.y, idxBg.size.w, idxBg.size.h);
      obj.isNoImageObject = true;
      obj.drawColorBackground = true;
      obj.color = color(idxBg.noImageColor ?? '#c7ecf5');
    }
    else {
      obj = new SJ.ParalaxImage(idxBg.name, imgPos, idxBg.workingName, scale, subrect, null, idxBg.isSpriteSheetTexture, idxBg.tilemap);
    }

    if(obj) {
      if(this.audioArr){
        obj.audioArr = this.audioArr;
      }
      this.images.push(obj);
    }
  }

  draw(cameraPos) {
      // push();

        // translate(this.x + this.translate.x, this.y + this.translate.y);
        // translate(cameraPos.x*this.camScale, cameraPos.y*this.camScale);

        // translate((this.x + this.translate.x) * -1, (this.y + this.translate.y) * -1);
        // translate((cameraPos.x*this.camScale) * -1, (cameraPos.y*this.camScale) * -1);

        // let cameraPoss = SJ.camera.getPosition();

        this.images.forEach(img => {
          if (img.isNoImageObject)
            img._draw();
          else
            img.draw(
              this.x + this.translate.x, this.y + this.translate.y,
              cameraPos.x, cameraPos.y, this.camScale
            );
        });



        // this.images.forEach(img => {
        //   img.draw(
        //     this.x + this.translate.x + cameraPos.x*this.camScale,
        //     this.y + this.translate.y + cameraPos.y*this.camScale
        //   );
        // });


      // pop();
  }
}